import React from "react";
import Wire01 from "./img/iep-wire01.jpg";
import Wire02 from "./img/iep-wire02.jpg";

function IEPCardWireframes() {
	return (
		<section className="card-iep-wires">
			<h2 className="title">Establishing a design workflow</h2>
			<div className="content-row">
				<article className="content">
					<p>
						The assets I had to begin work were marketing &amp; brand
						guidelines, documentation on the system architecture, and some
						initial business rules.
					</p>
					<p>
						The technical documentation included JSON objects which I used to
						sketch out concepts. Collaborating closely with a product owner, I
						then moved from sketches on paper of user-journeys to more high
						resolution wireframes.
					</p>
				</article>
				<div className="wire-group">
					<figure className="wire">
						<img src={Wire01} alt="Wireframe for Eligibility application" />
					</figure>
					<figure className="wire">
						<img src={Wire02} alt="Wireframe for Eligibility application" />
					</figure>
				</div>
			</div>
		</section>
	);
}

export default IEPCardWireframes;
